module.exports = __webpack_public_path__ + "static/media/banner-background.a501ee68.png";